export default __webpack_public_path__ + "static/media/top_demo_image_posts.49541a4d.png";